var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.143 5.0286C12.8288 4.7143 12.3191 4.71425 12.0047 5.02854C11.6904 5.34289 11.6904 5.85252 12.0047 6.16687L14.387 8.54923H4.52465C4.08012 8.54923 3.71973 8.90962 3.71973 9.35415C3.71973 9.79868 4.08012 10.1591 4.52465 10.1591H14.3869L12.0047 12.5412C11.6904 12.8556 11.6904 13.3652 12.0047 13.6795C12.1619 13.8367 12.3679 13.9153 12.5739 13.9153C12.7799 13.9153 12.9859 13.8367 13.143 13.6795L16.8992 9.92334C17.2136 9.60904 17.2136 9.09937 16.8992 8.78502L13.143 5.0286Z",
    fill: "#585757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28094 18.2083C8.72547 18.2083 9.08586 17.8479 9.08586 17.4034C9.08586 16.9589 8.72547 16.5985 8.28094 16.5985H2.10985V2.10985H8.28094C8.72547 2.10985 9.08586 1.74946 9.08586 1.30492C9.08586 0.860391 8.72547 0.5 8.28094 0.5H1.30492C0.860391 0.5 0.5 0.860391 0.5 1.30492V17.4034C0.5 17.8479 0.860391 18.2083 1.30492 18.2083H8.28094Z",
    fill: "#585757"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.ad0bca4bca2ad68e6a97f9b91ef0ab19.svg";
export { ForwardRef as ReactComponent };